import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { translateLeagueBreadcrumb } from '@/i18n/sports-label';
import { cn } from '@/lib/cn';
import { isFlagBadgeSrc } from '@/shell/sports-menu-utils';
import { Icon } from '../common/icon';

export interface LiveEventDetailNavProps {
  league: string;
  categoryName?: string | null;
  categoryId?: number | null;
  tournamentName?: string | null;
  tournamentId?: number | null;
  crestSrc?: string;
  sport?: string;
  tournament?: string;
  className?: string;
}

export function LiveEventDetailNav({
  league,
  categoryName,
  categoryId,
  tournamentName,
  tournamentId,
  crestSrc,
  sport,
  tournament,
  className,
}: LiveEventDetailNavProps) {
  const { t, i18n } = useTranslation();
  const leagueLabel =
    categoryName || tournamentName
      ? translateLeagueBreadcrumb(
          i18n,
          t,
          {
            category: categoryName,
            categoryId,
            tournament: tournamentName,
            tournamentId,
          },
          ' > ',
        ) || league
      : league;

  return (
    <nav
      className={cn('flex items-center gap-2', className)}
      aria-label={t('Event', { defaultValue: 'Event' })}
    >
      <Link
        to="/live"
        search={{ sport, tournament, media: undefined }}
        aria-label={t('Back to live', { defaultValue: 'Back to live' })}
        className="flex size-[18px] shrink-0 items-center justify-center text-icon-default"
      >
        <Icon name="arrow-right" size={18} className="-scale-x-100" />
      </Link>
      <div className="flex min-w-0 flex-1 items-center gap-1.5">
        {crestSrc ? (
          <span
            className={cn(
              'flex size-[18px] shrink-0 items-center justify-center overflow-clip rounded-full',
              !isFlagBadgeSrc(crestSrc) && 'bg-white',
            )}
          >
            <img
              src={crestSrc}
              alt=""
              className={
                isFlagBadgeSrc(crestSrc) ? 'size-full object-cover' : 'size-3.5 object-contain'
              }
            />
          </span>
        ) : null}
        <p className="truncate text-caption text-text-primary">{leagueLabel}</p>
      </div>
    </nav>
  );
}
